import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AppNgAppkitModule } from '../app-ng-appkit.module';
import { AppNgMaterialModule } from '../app-ng-material.module';
import { SharedComponentsModule } from '../shared/components/shared-components.module';
import { SharedDirectivesModule } from '../shared/_directives/shared-directives.module';

import { RetriggerGroupSyncComponent } from './components/retrigger-group-sync/retrigger-group-sync.component';
import { SltApiResponseComponent } from './components/slt-api-response/slt-api-response.component';
import { SltDataGenerationComponent } from './components/slt-data-generation/slt-data-generation.component';
import { SltIsDuplicateComponent } from './components/slt-is-duplicate/slt-is-duplicate.component';
import { SltKeySetupComponent } from './components/slt-key-setup/slt-key-setup.component';
import { SltSyncErrorComponent } from './components/slt-sync-error/slt-sync-error.component';
import { ChangeLogMonitorService } from './services/change-log-monitor.service';
import { ChangeLogMonitorComponent } from './components/change-log-monitor/change-log-monitor.component';
import { RegenerationProcessComponent } from './components/change-log-monitor/regeneration-process/regeneration-process.component';
import { RerunPdfGenerationComponent } from './components/change-log-monitor/rerun-pdf-generation/rerun-pdf-generation.component';
import { RerunXmlGenerationComponent } from './components/change-log-monitor/rerun-xml-generation/rerun-xml-generation.component';
import { RetriggerMessageComponent } from './components/change-log-monitor/retrigger-message/retrigger-message.component';

@NgModule({
  declarations: [
    RetriggerGroupSyncComponent,
    SltApiResponseComponent,
    SltDataGenerationComponent,
    SltIsDuplicateComponent,
    SltKeySetupComponent,
    SltSyncErrorComponent,
    ChangeLogMonitorComponent,
    RegenerationProcessComponent,
    RerunPdfGenerationComponent,
    RerunXmlGenerationComponent,
    RetriggerMessageComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    AppNgMaterialModule,
    AppNgAppkitModule,
    SharedComponentsModule,
    SharedDirectivesModule
  ],
  exports: [
    RetriggerGroupSyncComponent,
    SltApiResponseComponent,
    SltDataGenerationComponent,
    SltIsDuplicateComponent,
    SltKeySetupComponent,
    SltSyncErrorComponent,
    ChangeLogMonitorComponent,
    RegenerationProcessComponent,
    RerunPdfGenerationComponent,
    RerunXmlGenerationComponent,
    RetriggerMessageComponent
  ],
  providers: [
    ChangeLogMonitorService
  ]
})
export class SltDashboardModule { }
